/*
 * Copyright 2026 North Carolina State University
 */

/**
 * Optional modules — which ones this deployment has switched on.
 *
 * The server decides (backend/config/modules.js); the app asks once per page
 * load. If the call fails, every module is treated as off, so the core keeps
 * working whatever happens here.
 */

import React, { useEffect, useState } from 'react';
import axios from 'axios';

let pending = null;

const fetchEnabled = () => {
  if (!pending) {
    pending = axios.get('/api/modules')
      .then(res => res.data?.enabled || [])
      .catch(() => {
        pending = null; // try again on the next mount, e.g. after signing in
        return [];
      });
  }
  return pending;
};

/** true / false once known, null while loading. */
export const useModuleEnabled = (key) => {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchEnabled().then(list => { if (alive) setEnabled(list.includes(key)); });
    return () => { alive = false; };
  }, [key]);
  return enabled;
};

/** Renders children only when the module is on. */
export const ModuleGate = ({ module, children, fallback = null }) => {
  const enabled = useModuleEnabled(module);
  if (enabled === null) return null;
  return enabled ? children : fallback;
};

export const ModuleDisabled = () => (
  <div style={{ padding: '2rem' }}>
    <h2>Module not available</h2>
    <p>This module is not enabled for your installation.</p>
  </div>
);
